import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=69b886f6&"
import script from "./LinkExpired.vue?vue&type=script&lang=js&"
export * from "./LinkExpired.vue?vue&type=script&lang=js&"
import style0 from "./LinkExpired.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports